module.exports = __webpack_public_path__ + "static/media/testimonialport3.14459e04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonialport3.jpg
// module id = 467
// module chunks = 0